import { distinctUntilChanged, debounceTime } from 'rxjs/operators';
import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import {
  DAY_STRINGS,
  TabbedFilterItem,
  TabbedFilterItemValue
} from '../TABBED_FILTERS_CONFIG';
import { BehaviorSubject } from 'rxjs';
import { DomainService } from '../../../../services/domain-service';
import { AppService } from '../../../../services/app-service';
import { ActivatedRoute, Router } from '@angular/router';
import {
  ImportedFile,
  PresetConfig,
  PresetData
} from '../models/discovery.models';
import { DiscoveryUtilFunctions } from '../discovery-util-functions';
import { CapitalizePipe } from '../../../../pipes/capitalize.pipe';
import { CtvService } from '../../../../services/ctv-service';
import { User } from '../../../../models/User';

declare var jQuery;
declare var PerfectScrollbar;

@Component({
  selector: 'app-side-filters',
  templateUrl: './side-filters.component.html',
  styleUrls: ['./side-filters.component.scss']
})
export class SideFiltersComponent implements OnInit {
  @Input() currentConfig: any;
  @Input() currentCannedReportUpdater: EventEmitter<any>;
  @Input() importedFileNameUpdater: EventEmitter<string>;
  @Input() facetsUpdater: EventEmitter<any>;
  @Input() routeFilterValuesUpdater: EventEmitter<any>;
  @Input() foundFiltersUpdater: EventEmitter<any>;
  @Input() searchInputValueUpdater: EventEmitter<string>;
  @Input() routeRefreshUpdater: EventEmitter<any>;
  @Input() importStatusInvoker: EventEmitter<string>;
  @Input() refreshDataInvoker: EventEmitter<boolean>;
  @Input() clearAppGlobalSearchInputInvoker: EventEmitter<boolean>;
  @Input() selectedFilterValues: TabbedFilterItemValue[];
  @Input() cannedreports: Array<any>;
  @Input() loadingData: boolean;
  @Input() noFacets: boolean;
  @Input() facets: any;
  @Input() onDropdownFilterSelectInvoker: EventEmitter<any>;
  @Input() showOptionsInvoker: EventEmitter<any>;
  @Input() importListInvoker: EventEmitter<boolean>;
  @Input() presetsListInvoker: EventEmitter<boolean>;
  @Input() prepareFiltersInvoker: EventEmitter<boolean>;
  @Input() bulkUploadReportId: string;
  @Input() showFollowing: boolean;
  @Output() followingClickAction: EventEmitter<boolean> =
    new EventEmitter<boolean>();
  @Input() followingCount: number;
  @Input() appGlobalSearchParam: string;
  @Output() closeMobileNavClick: EventEmitter<boolean> =
    new EventEmitter<boolean>();
  @Output() clearAllFiltersClick: EventEmitter<boolean> =
    new EventEmitter<boolean>();

  @ViewChild('mobileBtnClose') mobileBtnClose: ElementRef | any;

  presetsList: Array<PresetConfig>;
  importList: Array<ImportedFile>;
  currentTimeMills: number;
  currentPreset: PresetConfig;
  foundFilters: Array<TabbedFilterItem> = null;
  inputSubject = new BehaviorSubject(undefined);
  searchInputValue: string = null;
  IMG_URL_PREFIX = `<img width='16' height='16' src='https://cdn.pixalate.com/sellers/icons/apn/16x16/`;
  capitalizePipe: CapitalizePipe = new CapitalizePipe();
  mobileBreakPoint: any;

  constructor(
    private _domainService: DomainService,
    private _appService: AppService,
    private _ctvService: CtvService,
    private _route: ActivatedRoute,
    private _router: Router,
    public _userService: User
  ) {}

  ngOnInit() {
    this.inputSubject = new BehaviorSubject(undefined);
    this.inputSubject
      .pipe(debounceTime(300), distinctUntilChanged())
      .subscribe(input => {
        this.searchInputValue = input;
        this.showFilters(input);
      });
    this.foundFiltersUpdater.subscribe(value => {
      this.foundFilters = value;
    });
    this.searchInputValueUpdater.subscribe(value => {
      this.searchInputValue = value;
    });
    this.importListInvoker.subscribe(value => {
      let service = null;

      if (this.currentConfig.key === 'apps') {
        service = this._appService.getImportList();
      } else if (this.currentConfig.key === 'domains') {
        service = this._domainService.getImportList();
      } else if (this.currentConfig.key === 'ctv') {
        service = this._ctvService.getImportList();
      }

      if (service) {
        service.then(response => {
          if (response && response['docs'] && response['docs'].length > 0) {
            this.importList = response['docs'];
            this.currentTimeMills = new Date().getTime();

            setTimeout(() => {
              const container = document.querySelector('.imported-list');
              if (container) {
                const ps = new PerfectScrollbar(container);
              }
            }, 100);
          } else {
            this.importList = [];
          }
        });
      } else {
        this.importList = [];
      }
    });
    this.presetsListInvoker.subscribe(value => {
      let key = null;
      if (this.currentConfig.key === 'apps') {
        key = 'appDiscovery';
      } else if (this.currentConfig.key === 'domains') {
        key = 'domainDiscovery';
      } else if (this.currentConfig.key === 'ctv') {
        key = 'ctvDiscovery';
      }

      this._appService.listPresets(key).then(response => {
        this.presetsList = [];
        if (response && response['docs'] && response['docs'].length > 0) {
          this.presetsList = response['docs'];
          this.initializeCollapseComps();
        }
      });
    });
    this.prepareFiltersInvoker.subscribe(value => {
      this.prepareFilters();
    });
    this.showOptionsInvoker.subscribe(value => {
      this.showOptions(value.tabbedFilterItem, value.forceRefresh);
    });
    this.mobileBreakPoint = window.matchMedia('(max-width: 576px)');
  }

  closeMobileNav(event?: any) {
    if (this.mobileBreakPoint.matches) {
      this.closeMobileNavClick.emit(true);
    }
  }

  showOptions(tabbedFilterItem: TabbedFilterItem, forceRefresh?: boolean) {
    if (
      tabbedFilterItem.previousSearchString !== tabbedFilterItem.searchString ||
      tabbedFilterItem.options.length <= 0 ||
      forceRefresh
    ) {
      // tabbedFilterItem.options = [];
      let newOptions = [];
      tabbedFilterItem.previousSearchString = tabbedFilterItem.searchString;
      tabbedFilterItem.optionsLoading = true;
      const foundItem = false;
      if (!foundItem) {
        if (tabbedFilterItem.metadataKey) {
          this._domainService
            .getDropdownItems(
              tabbedFilterItem.metadataKey,
              tabbedFilterItem.searchString,
              tabbedFilterItem.options.length,
              50
            )
            .then(response => {
              tabbedFilterItem.optionsCount = response['numFound'];
              const newItems = response['docs'].map(doc => ({
                text:
                  tabbedFilterItem.metadataKey === 'sellerId'
                    ? `${this.IMG_URL_PREFIX}${doc.id}.jpg'/> ${doc.name}`
                    : doc.name,
                value: doc.id,
                icon: null,
                selected: false
              }));
              setTimeout(() => {
                // tabbedFilterItem.options = tabbedFilterItem.options.concat(newItems);
                newOptions = newOptions.concat(newItems);
                tabbedFilterItem.options = newOptions;
                tabbedFilterItem.optionsLoading = false;
              }, 1);
              if (tabbedFilterItem.metadataKey === 'sellerId') {
                setTimeout(() => {
                  jQuery('img').on('error', function () {
                    this.style.opacity = 0;
                  });
                }, 300);
              }
              setTimeout(() => {
                const container = document.querySelector(
                  '.items-cont.' + tabbedFilterItem.param
                );
                if (container) {
                  const ps = new PerfectScrollbar(container);
                }
              }, 5000);
            });
        } else {
          const newList = true;
          const bulkUploadReportId =
            this._route.snapshot.queryParams['bulkUploadReportId'];
          const filterStrings = DiscoveryUtilFunctions.getFilterStrings(
            this.currentConfig,
            this.selectedFilterValues,
            this.cannedreports,
            bulkUploadReportId,
            this.currentCannedReportUpdater,
            this.importedFileNameUpdater
          ).filter(filter => filter.indexOf(tabbedFilterItem.param + '=') < 0);
          const device = this.currentConfig.mainFilterItems.filter(
            filter => filter.apiKey === 'device'
          )[0].selected.apiValue;
          const region = this.currentConfig.mainFilterItems.filter(
            filter => filter.apiKey === 'region'
          )[0].selected.apiValue;
          let paramArray = [tabbedFilterItem.param];
          if (tabbedFilterItem.param === 'trustedSellerName') {
            paramArray = ['trustedSellerNameId'];
          }
          const paraContains = tabbedFilterItem.param + 'Contains';
          let service = null;
          if (this.showFollowing) {
            filterStrings.push(
              `userId=${this._userService.getIdentity().userEmailAddress}`
            );
          }
          if (this.currentConfig.key === 'apps') {
            if (
              this.appGlobalSearchParam &&
              this.appGlobalSearchParam.length > 0
            ) {
              filterStrings.push(
                `appGlobalSearchParam=${this.appGlobalSearchParam}`
              );
            }
            service = this._appService.getFacetsBySearch(
              device,
              region,
              paramArray,
              paraContains,
              tabbedFilterItem.searchString,
              filterStrings.join('&')
            );
          } else if (this.currentConfig.key === 'domains') {
            const isSubDomain = this.currentConfig.mainFilterItems.filter(
              filter => filter.apiKey === 'isSubDomain'
            )[0].selected.apiValue;
            service = this._domainService.getFacetsBySearch(
              device,
              region,
              isSubDomain,
              paramArray,
              paraContains,
              tabbedFilterItem.searchString,
              filterStrings.join('&')
            );
          } else if (this.currentConfig.key === 'ctv') {
            service = this._ctvService.getFacetsBySearch(
              device,
              region,
              paramArray,
              paraContains,
              tabbedFilterItem.searchString,
              filterStrings.join('&')
            );
          }

          if (service !== null) {
            service.then(response => {
              const newSellerList = [];
              const sellerMapping = {};
              if (
                response &&
                response['facets'] &&
                response['facets'][paramArray[0]]
              ) {
                const sellerNames = response['facets'][paramArray[0]];

                const sellerNameKeys = [];
                if (sellerNames && sellerNames.length > 0) {
                  for (const sellerName of sellerNames) {
                    const keys = Object.keys(sellerName);
                    let name = keys[0];
                    const value = sellerName[name];
                    let icon = '';
                    if (tabbedFilterItem.param === 'trustedSellerName') {
                      const nameId = keys[0];
                      const firstIndex = nameId.lastIndexOf('(');
                      const secondIndex = nameId.lastIndexOf(')');
                      name = nameId.substring(0, firstIndex);
                      const sellerId = nameId.substring(
                        firstIndex + 1,
                        secondIndex
                      );
                      icon =
                        `https://cdn.pixalate.com/sellers/icons/apn/16x16/${sellerId}.jpg?cb=` +
                        Math.random();
                    }

                    sellerNameKeys.push(name);
                    sellerMapping[name] = value;

                    const newSeller = {
                      icon: icon,
                      text: name,
                      value: name,
                      selected: false
                    };

                    if (tabbedFilterItem.param === 'dayOfWeek') {
                      newSeller.text = DAY_STRINGS[Number.parseInt(name)];
                    }

                    if (tabbedFilterItem.param === 'developerCountry') {
                      newSeller.text = this.capitalizePipe.transform(
                        newSeller.text
                      );
                    }

                    if (tabbedFilterItem.param === 'tld') {
                      newSeller.text = newSeller.text.toLowerCase();
                    }

                    if (
                      name &&
                      name.length > 0 &&
                      name !== 'N/A' &&
                      name !== 'Other' &&
                      name !== 'null'
                    ) {
                      newSellerList.push(newSeller);
                    }
                  }
                }
              }

              if (newList) {
                // tabbedFilterItem.options = [];
              }

              // TODO: call facetsUpdater to update facets
              // this.facets[tabbedFilterItem.param] = sellerMapping;
              this.facetsUpdater.emit({
                param: tabbedFilterItem.param,
                mapping: sellerMapping
              });

              tabbedFilterItem.optionsLoading = false;
              // tabbedFilterItem.options = tabbedFilterItem.options.concat(newSellerList);
              newOptions = newOptions.concat(newSellerList);
              tabbedFilterItem.options = newOptions;
              tabbedFilterItem.optionsCount = tabbedFilterItem.options.length;

              setTimeout(() => {
                const container = document.querySelector(
                  '.items-cont.' + tabbedFilterItem.param
                );
                if (container) {
                  const ps = new PerfectScrollbar(container);
                }
              }, 100);
            });
          }

          if (
            tabbedFilterItem.param === 'dayOfWeek' &&
            tabbedFilterItem.options.length <= 0
          ) {
            // set dayofweek dropdown
            // let dayItems = [];
            // [1, 2, 3, 4, 5, 6, 7].forEach(num => {
            //     dayItems.push({ icon: '', 'text': DAY_STRINGS[num], 'value': num, 'selected': false });
            // });
            //
            // this.selectedFilterValues.filter(filter => filter.param === 'dayOfWeek').forEach(filter => {
            //     filter.valueLabel = dayItems.filter(day => day.value === filter.value)[0].text;
            // });
            //
            // tabbedFilterItem.options = dayItems;
            // tabbedFilterItem.optionsLoading = false;
          }
        }
      }
      // jQuery('.collapse.level2[paramkey!="' + tabbedFilterItem.param + '"]').collapse('hide');
    }
  }

  prepareFilters() {
    const foundAppStoreFilter = this.currentConfig.mainFilterItems.filter(
      mainFilter => mainFilter.apiKey === 'appStore'
    );
    const foundRegionFilter = this.currentConfig.mainFilterItems.filter(
      mainFilter => mainFilter.apiKey === 'region'
    );
    let hideDownloadsFilter = false; // Downloads filter only for google play
    let hideInAppPurchasesFilter = false; // In App Purchases filter only for google play
    let hidePermissionsRiskFilter = false; // Permissions Risk filter only for google play
    let hideBundleIdFilter = false; // Bundle ID Filter only for google play
    const hideTopDMA = false; // Top DMA only for US Region
    if (foundAppStoreFilter && foundAppStoreFilter[0]) {
      hideDownloadsFilter =
        foundAppStoreFilter[0].selected.apiValue !== 'android';
      hideInAppPurchasesFilter =
        foundAppStoreFilter[0].selected.apiValue !== 'android';
      hidePermissionsRiskFilter =
        foundAppStoreFilter[0].selected.apiValue !== 'android';
      hideBundleIdFilter =
        foundAppStoreFilter[0].selected.apiValue !== 'android';
    }
    this.currentConfig.topLevelCategories.forEach(topLevelCategory => {
      topLevelCategory.groups.forEach(tabbedGroup => {
        const device = this._route.snapshot.params['param1'];
        if (tabbedGroup.hiddenFor?.indexOf(device) > -1) {
          tabbedGroup.hidden = true;
        } else {
          tabbedGroup.hidden = false;
        }

        tabbedGroup.items.forEach(filterItem => {
          if (filterItem.param === 'downloads') {
            filterItem.hidden = hideDownloadsFilter;
          } else if (filterItem.param === 'hasInAppPurchases') {
            filterItem.hidden = hideInAppPurchasesFilter;
          } else if (filterItem.param === 'overallIvtPermissionRisk') {
            filterItem.hidden = hidePermissionsRiskFilter;
          } else if (filterItem.param === 'bundleId') {
            filterItem.hidden = hideBundleIdFilter;
          }

          if (this.currentConfig.key === 'domains') {
            const foundMainFilter = this.currentConfig.mainFilterItems.filter(
              mainFilter => mainFilter.apiKey === 'region'
            );
            if (foundMainFilter && foundMainFilter[0]) {
              let selectedRegion = foundMainFilter[0].selected.label;
              if (filterItem.param === 'totalInventory') {
                if (selectedRegion !== 'US') {
                  selectedRegion =
                    selectedRegion[0] +
                    selectedRegion.toLocaleLowerCase().substring(1);
                }
                let newLabel = filterItem.label;
                newLabel = `${selectedRegion} Inventory Available`;
                filterItem.label = newLabel;
              } else if (filterItem.param === 'country') {
                if (selectedRegion === 'US') {
                  filterItem.hidden = true;
                } else {
                  filterItem.hidden = false;
                }
              } else if (filterItem.param === 'dma') {
                // We only show Top DMA for US Region
                filterItem.hidden = selectedRegion !== 'US';
              }
            }
          }

          if (this.currentConfig.key === 'apps') {
            if (filterItem.param === 'category') {
              let label = 'App Store Categories';
              if (foundAppStoreFilter[0].selected.apiValue === 'android') {
                label = 'Play Store Categories';
              }
              filterItem.label = label;
            } else if (filterItem.param === 'isExistInAppStore') {
              let label = 'Exist In App Store';
              if (foundAppStoreFilter[0].selected.apiValue === 'android') {
                label = 'Exist In Play Store';
              }
              filterItem.label = label;
            }
          } else if (this.currentConfig.key === 'ctv') {
            if (filterItem.param === 'category') {
              let label = 'Roku Store Categories';
              if (device === 'firetv') {
                label = 'Fire TV Store Categories';
              } else if (device === 'samsung') {
                label = 'Samsung Store Categories';
              } else if (device === 'tvos') {
                label = 'tvOS Store Categories';
              }
              filterItem.label = label;
            }

            if (filterItem.hiddenFor?.indexOf(device) > -1) {
              filterItem.hidden = true;
            } else {
              filterItem.hidden = false;
            }
          }
        });
      });
    });

    this.initializeCollapseComps();
  }

  initializeCollapseComps() {
    setTimeout(() => {
      jQuery('.collapse.level2').on('show.bs.collapse', function () {
        jQuery(this).parent('.card').addClass('show');
        jQuery('.precanned-reports-cont').scrollTop(0);
      });
      jQuery('.collapse.level2').on('hide.bs.collapse', function () {
        jQuery(this).parent('.card').removeClass('show');
      });

      const inst = this;
      jQuery('.collapse.level1').on('show.bs.collapse', function () {
        jQuery(this).parent('.canned-cont').addClass('show');
        const tabbedGroupKey = jQuery(this).data('tabbedgroup-key');
        inst.currentConfig.topLevelCategories.forEach(topLevelCategory => {
          topLevelCategory.groups.forEach(tabbedGroup => {
            if (tabbedGroup.key !== tabbedGroupKey) {
              if (tabbedGroup.items.length > 1) {
                jQuery(
                  '.collapse[data-tabbedgroup-key="' + tabbedGroup.key + '"]'
                ).collapse('hide');
              } else {
                jQuery(
                  '.collapse[data-tabbedgroup-key="' +
                    tabbedGroup.key +
                    '"] .collapse.level2'
                ).collapse('hide');
              }
            }
          });
        });
        jQuery('.precanned-reports-cont').scrollTop(0);
      });

      jQuery('.collapse.level1').on('hide.bs.collapse', function (event) {
        const isLevel1 = jQuery(event.target).hasClass('level1');
        if (isLevel1) {
          jQuery(this).parent('.canned-cont').removeClass('show');
        } else {
          if (jQuery(this).parent('.canned-cont').hasClass('only-one-item')) {
            jQuery(this).parent('.canned-cont').removeClass('show');
          }
        }
      });
    }, 300);
  }

  searchFilters(input: any) {
    this.inputSubject.next(input);
  }

  showFilters(filterString: string) {
    const device = this._route.snapshot.params['param1'];
    const foundAppStoreFilter = this.currentConfig.mainFilterItems.filter(
      mainFilter => mainFilter.apiKey === 'appStore'
    );
    const foundRegionFilter = this.currentConfig.mainFilterItems.filter(
      mainFilter => mainFilter.apiKey === 'region'
    );
    let hideDownloadsFilter = false; // Downloads filter only for google play
    let hideInAppPurchasesFilter = false; // In App Purchases filter only for google play
    const hideTopDMA = false; // Top DMA only for US Region
    if (foundAppStoreFilter && foundAppStoreFilter[0]) {
      hideDownloadsFilter =
        foundAppStoreFilter[0].selected.apiValue !== 'android';
      hideInAppPurchasesFilter =
        foundAppStoreFilter[0].selected.apiValue !== 'android';
    }
    if (filterString && filterString.length > 0) {
      const filters = new Array<TabbedFilterItem>();
      if (filterString && filterString.length > 0) {
        this.currentConfig.topLevelCategories.forEach(category => {
          category.groups.forEach(group => {
            group.items.forEach(groupItem => {
              const label = groupItem.label;
              if (
                label.toLowerCase().indexOf(filterString.toLowerCase()) >= 0
              ) {
                let addFilter = true;
                if (groupItem.param === 'downloads' && hideDownloadsFilter) {
                  addFilter = false;
                } else if (
                  groupItem.param === 'hasInAppPurchases' &&
                  hideInAppPurchasesFilter
                ) {
                  addFilter = false;
                }

                if (this.currentConfig.key === 'domains') {
                  const foundMainFilter =
                    this.currentConfig.mainFilterItems.filter(
                      mainFilter => mainFilter.apiKey === 'region'
                    );
                  if (foundMainFilter && foundMainFilter[0]) {
                    let selectedRegion = foundMainFilter[0].selected.label;
                    if (groupItem.param === 'totalInventory') {
                      if (selectedRegion !== 'US') {
                        selectedRegion =
                          selectedRegion[0] +
                          selectedRegion.toLocaleLowerCase().substring(1);
                      }
                      let newLabel = groupItem.label;
                      newLabel = `${selectedRegion} Inventory Available`;
                      groupItem.label = newLabel;
                    } else if (groupItem.param === 'country') {
                      if (selectedRegion === 'US') {
                        addFilter = false;
                      } else {
                      }
                    } else if (
                      groupItem.param === 'dma' &&
                      selectedRegion !== 'US'
                    ) {
                      // We only show Top DMA for US Region
                      addFilter = false;
                    }
                  }
                } else if (this.currentConfig.key === 'ctv') {
                  if (groupItem.hiddenFor?.indexOf(device) > -1) {
                    addFilter = false;
                  }
                }
                if (addFilter) {
                  filters.push(groupItem);
                }
              }
            });
          });
        });
      }
      this.foundFilters = filters;

      setTimeout(() => {
        jQuery('.searched-filters .collapse').on(
          'show.bs.collapse',
          function () {
            jQuery(this).parent('.card').addClass('show');
          }
        );
        jQuery('.searched-filters .collapse').on(
          'hide.bs.collapse',
          function () {
            jQuery(this).parent('.card').removeClass('show');
          }
        );
      }, 300);
    } else {
      this.foundFilters = null;
    }
  }

  followingClick() {
    this.followingClickAction.emit(true);
    this.closeMobileNav();
  }

  importFileClick(bulkUploadReportId: string) {
    if (bulkUploadReportId) {
      this.routeRefreshUpdater.emit({
        additionalQueryParams: { bulkUploadReportId: bulkUploadReportId }
      });
      this.importStatusInvoker.emit(bulkUploadReportId);
    }
  }

  deleteImportedFile(bulkUploadReportIdSelected: string) {
    const bulkUploadReportId =
      this._route.snapshot.queryParams['bulkUploadReportId'];

    // this._appService.deleteImportedFile(bulkUploadReportIdSelected).then((response) => {
    //       //   if (bulkUploadReportId && bulkUploadReportIdSelected === bulkUploadReportId) {
    //       //     this.routeRefresh({bulkUploadReportId: null});
    //       //     this.refreshData();
    //       //   } else {
    //       //     this.loadImportList();
    //       //   }
    //       // });
  }

  loadPreset(presetConfig: PresetConfig) {
    let service = null;
    let routeParams = null;
    if (this.currentConfig.key === 'apps') {
      service = this._appService.loadPreset(presetConfig.reportId);
      routeParams = ['/discovery', 'apps', 'dashboard'];
    } else if (this.currentConfig.key === 'domains') {
      service = this._appService.loadPreset(presetConfig.reportId);
      routeParams = ['/discovery', 'domains', 'dashboard'];
    } else if (this.currentConfig.key === 'ctv') {
      service = this._appService.loadPreset(presetConfig.reportId);
      routeParams = ['/discovery', 'ctv', 'dashboard'];
    }

    if (service !== null && routeParams !== null) {
      service.then(async (presetData: PresetData) => {
        // /discovery/apps/dashboard/ios/all/GLOBAL?violenceContentRating=H
        const queryParams = {};
        if (presetData.reportConfig.otherFilters) {
          if (Array.isArray(presetData.reportConfig.otherFilters)) {
            presetData.reportConfig.otherFilters.forEach(otherFilter => {
              const param = Object.keys(otherFilter)[0];
              if (queryParams[param]) {
                queryParams[param] += '()' + otherFilter[param];
              } else {
                queryParams[param] = otherFilter[param];
              }
            });
          } else {
            const param = Object.keys(presetData.reportConfig.otherFilters)[0];
            queryParams[param] = presetData.reportConfig.otherFilters[param];
          }
        }
        if (this.currentConfig.key === 'apps') {
          routeParams.push(presetData.reportConfig.topFilters['appStore']);
          routeParams.push(presetData.reportConfig.topFilters['device']);
          routeParams.push(presetData.reportConfig.topFilters['region']);
        } else if (this.currentConfig.key === 'domains') {
          routeParams.push(presetData.reportConfig.topFilters['device']);
          routeParams.push(presetData.reportConfig.topFilters['region']);
          routeParams.push(presetData.reportConfig.topFilters['isSubDomain']);
        } else if (this.currentConfig.key === 'ctv') {
          routeParams.push(presetData.reportConfig.topFilters['device']);
          routeParams.push(presetData.reportConfig.topFilters['region']);
          routeParams.push(presetData.reportConfig.topFilters['brand']);
        }

        await this._router.navigate(routeParams, {
          queryParams: queryParams
        });

        this.currentPreset = presetConfig;
        if (!queryParams['appGlobalSearchParam']) {
          this.clearAppGlobalSearchInputInvoker.emit(true);
        }
        this.refreshDataInvoker.emit(true);
        this.closeMobileNav();
      });
    }
  }

  deletePreset(event: any, presetConfig: PresetConfig) {
    if (event) {
      event.stopPropagation();
    }

    this._appService
      .deletePreset(presetConfig.reportId)
      .then((presetData: PresetData) => {
        if (
          this.currentPreset &&
          this.currentPreset.reportId === presetConfig.reportId
        ) {
          this.routeRefreshUpdater.emit(null);
          this.currentPreset = null;
        }

        this.refreshDataInvoker.emit(true);

        this.presetsListInvoker.emit(true);
      });
  }

  cannedClick(report?: any) {
    const paramMap = report.filters;
    const mainFilterMap = report.mainFilters;
    if (mainFilterMap) {
      const keys = Object.keys(mainFilterMap);
      keys.forEach(key => {
        const mainFilter = this.currentConfig.mainFilterItems.filter(
          filter => filter.apiKey === key
        );
        if (mainFilter && mainFilter[0]) {
          const mainFilterOption = mainFilter[0].options.filter(
            option => option.value === mainFilterMap[key]
          );
          if (mainFilterOption && mainFilterOption[0]) {
            mainFilter[0].selected = mainFilterOption[0];
          }
        }
      });
    }

    this.clearAppGlobalSearchInputInvoker.emit(true);
    this.routeRefreshUpdater.emit({ additionalQueryParams: paramMap });
    this.closeMobileNav();
  }

  clearSearchFilters() {
    this.searchFilters('');
    jQuery('input.search-keywords').focus();
  }

  clearAllFilters() {
    this.clearAllFiltersClick.emit(true);
  }
}
